import React, { useEffect, useState } from 'react';
import { useField } from 'formik';
import Select from 'react-select';
import { Form, FormGroup } from 'react-bootstrap';
import { SimpleOption } from './Option/SimpleOption';
import './Select.scss';
import placeholder from 'lodash/fp/placeholder';
import { translateTabContentText } from 'utils/helpers/useTranslation';

interface IProps {
  translations?: any;
  name: string;
  labelText?: string;
  options: Array<any>;
  disabled?: boolean;
  required?: boolean;
  imageFile?: any;
  OriginalHeight?: number | null;
  ImageHeight?: number | null;
  OriginalWidth?: number | null;
  ImageWidth?: number | null;
  OriginalSize?: boolean;
  MaintainAspectRatio?: boolean;
  placeholder?: string;
  newData?: any;
  oneField?: any;
  setNewData?: React.Dispatch<React.SetStateAction<any>>;
}

const SelectInput = ({
  setNewData,
  oneField,
  newData,
  translations,
  name,
  labelText,
  options,
  imageFile,
  disabled = false,
  required = false,
  placeholder,
  OriginalSize,
  OriginalWidth,
  OriginalHeight,
  ImageHeight,
  ImageWidth,
  MaintainAspectRatio,
}: IProps) => {
  const [field, meta, helpers] = useField(name);
  const [newOptions, setNewOptions] = useState([]);

  useEffect(() => {
    const translatedOptions = options?.map(o => ({
      value: o.value,
      label: translateTabContentText(o.label, translations),
    }));
    setNewOptions(translatedOptions);
  }, []);

  const changeFieldsValue = checkedValue => {
    const findField = newData?.[0].Pages.map(tab =>
      tab.Fields.forEach(f => {
        if (f.Template.ID === oneField.Template.ID) {
          f.Value = checkedValue;
        }
      }),
    );
  };

  return (
    <Form.Group controlId={field.name} className="form-group-select">
      {labelText && (
        <Form.Label>
          {required && <span className="required-indicator">*</span>}
          {labelText}
        </Form.Label>
      )}
      {imageFile && OriginalSize ? (
        <img
          height={OriginalHeight}
          width={OriginalWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      {imageFile && !OriginalSize && !MaintainAspectRatio ? (
        <img
          height={ImageHeight}
          width={ImageWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      {imageFile && !OriginalSize && MaintainAspectRatio ? (
        <img
          width={ImageWidth}
          src={`data:image/png;base64, ${imageFile}`}
          alt="img"
        />
      ) : null}
      <Select
        selectProps={translations}
        className="simple-select"
        options={options}
        placeholder={placeholder}
        {...field}
        value={newOptions?.filter(o => o.value === field.value)}
        onChange={option => {
          helpers.setValue(option.value);
          changeFieldsValue(option.value);
        }}
        isDisabled={disabled}
        components={{
          Option: SimpleOption,
          IndicatorSeparator: null,
        }}
      />
      {meta.error && (
        <p className="error-wrapper">
          {translateTabContentText(meta.error, translations)}
        </p>
      )}
    </Form.Group>
  );
};

export { SelectInput };
